module.exports = __webpack_public_path__ + "guide.3MgZKU76.svg";